// ABOUTME: Derives the deployment environment and alternate-environment URL
// ABOUTME: from the host the client is served on.
import {
  Environment,
  altEnvUrlFromLocation,
  environmentFromHostname,
} from './environment';

export type { Environment };

// ============================================================================
// Deployment Environment
// ============================================================================
// The environment is a distinct DNS label in the deployment host, so it is
// derived from window.location at runtime. One build is promoted across
// environments and configures itself from the host it is served on. Local dev
// (no window) is development; an unrecognized host resolves to unknown caution.

const loc = typeof window === 'undefined' ? undefined : window.location;

export const environment: Environment = loc
  ? environmentFromHostname(loc.hostname)
  : 'development';

/** URL of the other deployment to reroute to when switching environments. */
export const altEnvUrl: string | undefined = loc
  ? altEnvUrlFromLocation(loc.protocol, loc.hostname)
  : undefined;
